import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Add, Remove } from '@mui/icons-material'
import { Button } from '@mui/material'

type AccessToggleButtonProps = {
  granted: boolean
  pending: boolean
  itemName: string
  onToggle: () => void
}

export const AccessToggleButton: FC<AccessToggleButtonProps> = ({ granted, pending, itemName, onToggle }) => {
  const { t } = useTranslation()
  return (
    <Button
      size="small"
      variant="outlined"
      color={granted ? 'warning' : 'success'}
      startIcon={granted ? <Remove /> : <Add />}
      disabled={pending}
      onClick={onToggle}
      aria-label={t(granted ? 'internal-csm:organization_access_revoke_from' : 'internal-csm:organization_access_grant_to', { name: itemName })}
      sx={{ whiteSpace: 'nowrap' }}
    >
      {t(granted ? 'internal-csm:organization_access_revoke' : 'internal-csm:organization_access_grant')}
    </Button>
  )
}
